// extracted by mini-css-extract-plugin
module.exports = {"figure":"ReverseFigure--figure--2II8L","background":"ReverseFigure--background--1eKOl"};